import { useSearchParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { ModalAction } from '../../../../context/ModalContext';
import { useState, useEffect } from 'react';
import { userGradeType } from '../../../../utils/auth';

interface DetailOrNplTabProps {
  tab: string;
  setTab: (tab: string) => void;
  modalDispatch?: React.Dispatch<ModalAction> | undefined;
}

const DetailOrNplTab = ({
  tab,
  setTab,
  modalDispatch,
}: DetailOrNplTabProps) => {
  const [searchParams] = useSearchParams();
  const listType = searchParams.get('type');

  const [userGrade, setUserGrade] = useState<string | null>(null);
  useEffect(() => {
    const fetchUserGrade = async () => {
      try {
        const grade = await userGradeType();
        setUserGrade(grade);
      } catch (error) {
        console.error('유저 등급 정보 가져오기 실패:', error);
      }
    };

    fetchUserGrade();
  }, []);

  if (listType === 'b') {
    return (
      <TabBox>
        <TabButton
          active={tab === 'auction'}
          onClick={() => {
            setTab('auction');
          }}
        >
          물건 상세분석
        </TabButton>
        <TabButton
          active={tab === 'npl'}
          onClick={() => {
            if (!userGrade && modalDispatch) {
              modalDispatch({ type: 'USER_ALERT', payload: 'free' });
              return;
            }
            setTab('npl');
          }}
        >
          부실채권 투자 수익분석
        </TabButton>
      </TabBox>
    );
  } else {
    return '';
  }
};

const TabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid rgba(112, 115, 124, 0.16);
`;
const TabButton = styled.span<{ active: boolean }>`
  flex: 1;
  padding: 10px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-weight: 500;
  color: ${(props) => (props.active ? '#222' : '#989BA2')};
  border-bottom: ${(props) => (props.active ? '2px solid #222' : 'none')};
  cursor: pointer;
`;

export default DetailOrNplTab;
